// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"9eb4b9d6","787":"718e1545","813":"7b2a8005","848":"2ca8bc4a","881":"313018e1"}[chunkId] + ".chunk.js";
};